import React from 'react';

import { cn } from '@blockworks/ui/utils';

type ICloseProps = {
    className?: string;
    style?: 'primary' | 'black';
    width?: number;
    height?: number;
};

const CloseIcon = (props: ICloseProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props.width}
            height={props.height}
            viewBox="0 0 8 8"
            fill="none"
            className={cn('relative', props.style === 'primary' ? 'text-primary' : 'text-black', props.className)}
        >
            <path
                d="M7.93494 1.49089L7.22994 0.785889L4.43494 3.58089L1.63994 0.785889L0.934937 1.49089L3.72994 4.28589L0.934937 7.08089L1.63994 7.78589L4.43494 4.99089L7.22994 7.78589L7.93494 7.08089L5.13994 4.28589L7.93494 1.49089Z"
                fill="#5637CD"
            />
        </svg>
    );
};

export default CloseIcon;
